var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.526,
    height: 20.687,
    viewBox: "0 0 16.526 20.687",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4303",
    "data-name": "Group 4303",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4169",
    "data-name": "Group 4169",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3375",
    "data-name": "Path 3375",
    d: "M14,3V7.161A1.04,1.04,0,0,0,15.04,8.2H19.2",
    transform: "translate(-4.297 -3)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3376",
    "data-name": "Path 3376",
    d: "M17.879,22.187H7.147A2.139,2.139,0,0,1,5,20.055V5.132A2.139,2.139,0,0,1,7.147,3H14.66l5.366,5.33V20.055A2.139,2.139,0,0,1,17.879,22.187Z",
    transform: "translate(-5 -3)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1128",
    "data-name": "Line 1128",
    x2: 1.243,
    transform: "translate(3.722 5.794)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1129",
    "data-name": "Line 1129",
    x2: 7.46,
    transform: "translate(3.783 10.86)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1130",
    "data-name": "Line 1130",
    x2: 7.46,
    transform: "translate(3.783 14.659)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrden);
export default __webpack_public_path__ + "static/media/icon_orden.59ce18a036e79c71bcf0db42db9b2b45.svg";
export { ForwardRef as ReactComponent };